import Header from "./components/Header";
import Footer from "./components/Footer";
import TokenConverter from "./TokenConverter";

function App() {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      
      {/* Main content */}
      <div className="flex-grow pt-24 pb-20 bg-gray-100 p-6 flex items-center justify-center">
        <TokenConverter />
      </div>

      <Footer />
    </div>
  );
}

export default App;
